import { useMutation } from '@apollo/client'
import { Button, Popconfirm, useMessage } from '@faceup/ui-base'
import { graphql } from '../__generated__'

type SendOpenIdUpdateEmailButtonProps = {
  motherId: string
}

const mutations = {
  sendCompanyOpenIdUpdateEmail: graphql(`
    mutation SendCompanyOpenIdUpdateEmailMutation($input: SendCompanyOpenIdUpdateEmailInput!) {
      sendCompanyOpenIdUpdateEmail(input: $input) {
        success
      }
    }
  `),
}

const RequestOpenIdConfigurationChangeButton = ({ motherId }: SendOpenIdUpdateEmailButtonProps) => {
  const message = useMessage()

  const [sendCompanyOpenIdUpdateEmail, { loading }] = useMutation(
    mutations.sendCompanyOpenIdUpdateEmail,
    {
      onError: () => {
        message.error('Failed to send the OpenID update email')
      },
      onCompleted: data => {
        if (data.sendCompanyOpenIdUpdateEmail?.success) {
          message.success('OpenID update email sent to the account owner')
          return
        }
        message.error('Failed to send the OpenID update email')
      },
    }
  )

  return (
    <Popconfirm
      title='Send the account owner an email with a link to update the OpenID (SSO) configuration? Any previously sent link will stop working.'
      onConfirm={() =>
        sendCompanyOpenIdUpdateEmail({
          variables: {
            input: {
              motherId,
            },
          },
        })
      }
    >
      <Button ghost type='primary' loading={loading}>
        Request SSO configuration change
      </Button>
    </Popconfirm>
  )
}

export default RequestOpenIdConfigurationChangeButton
